define.alias("shared/components/shared/ui/search-box/result-blank", "media/components/shared/ui/search-box/result-blank");